export var GitAccountType;
(function (GitAccountType) {
    GitAccountType["GIT_ACCOUNT_TYPE_ORGANIZATION"] = "ORGANIZATION";
    GitAccountType["GIT_ACCOUNT_TYPE_USER"] = "USER";
})(GitAccountType || (GitAccountType = {}));
